import React from 'react';
import { useField } from '@kuzmycz/react-form-ula';
import { InputField } from '../uielements';

const BioPlusTextField = ({ name, label, fullwidth, isError, ...rest }) => {
  const fieldContext = useField({ ...rest, name });
  const { error, touched } = fieldContext.errorProps;

  return (
    <InputField
      Name={label}
      isError={error}
      error={!!error && !!touched}
      helperText={touched ? error : ''}
      name={name}
      {...fieldContext.fieldProps}
    />
  );
};

export default BioPlusTextField;
